var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircleInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47656 2 2 6.47656 2 12C2 17.5234 6.47656 22 12 22C17.5234 22 22 17.5234 22 12C22 6.47656 17.5234 2 12 2ZM12 20.75C7.17578 20.75 3.25 16.8242 3.25 12C3.25 7.17578 7.17578 3.25 12 3.25C16.8242 3.25 20.75 7.17578 20.75 12C20.75 16.8242 16.8242 20.75 12 20.75ZM12 9.1875C12.5176 9.1875 12.9375 8.76797 12.9375 8.25C12.9375 7.73242 12.5176 7.3125 12 7.3125C11.4824 7.3125 11.0625 7.73047 11.0625 8.25C11.0625 8.76953 11.4805 9.1875 12 9.1875ZM13.875 15.75H12.625V11.375C12.625 11.0312 12.3438 10.75 12 10.75H10.75C10.4062 10.75 10.125 11.0312 10.125 11.375C10.125 11.7188 10.4062 12 10.75 12H11.375V15.75H10.125C9.78125 15.75 9.5 16.0312 9.5 16.375C9.5 16.7188 9.78125 17 10.125 17H13.875C14.2202 17 14.5 16.7202 14.5 16.375C14.5 16.0312 14.2188 15.75 13.875 15.75Z",
    fill: "#25282B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircleInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-info.77f1c71bc0843973cbf6a6a49763b880.svg";